import {
  EPromotionStatus,
  CMMFGroup,
  CMMF,
  Worklist,
  PromotionListFilter
} from '@/services/connecteur'
import serviceModule from '@/store/modules/ServiceModule'
import { EnumItem } from '@/models/Enum'
import i18n from '@/i18n'
import { Module, Action, Mutation, VuexModule, getModule } from 'vuex-module-decorators'
import store from '@/store'
type Dictionary<T> = { [key: string]: T }

@Module({ namespaced: true, name: 'promotionModule', dynamic: true, store })
export class PromotionModule extends VuexModule {
  public cmmfCache: Dictionary<CMMF[]> = {}
  public worklist: Worklist[] = new Array<Worklist>()
  public filter: PromotionListFilter = new PromotionListFilter({
    listOption: 1,
    selectedStatus: [
      EPromotionStatus.NEW,
      EPromotionStatus.DRAFT,
      EPromotionStatus.PREVALIDATED,
      EPromotionStatus.REWORK,
      EPromotionStatus.CHANGED,
      EPromotionStatus.BU_CHECK
      ]
  })

  public callbacks: CallableFunction[] = new Array<CallableFunction>()

  public get allStatusName (): EnumItem[] {
    const result = new Array<EnumItem>()
    for (const key in EPromotionStatus) {
      const id = Number.parseInt(key, 10)
      if (!isNaN(id)) {
        result.push({
          id: id,
          name: i18n.t(`promotionStatus.${EPromotionStatus[id]}`).toString()
        })
      }
    }

    return result
  }

  public get cmmfGroupName (): EnumItem[] {
    const result = new Array<EnumItem>()
    for (const key in CMMFGroup) {
      const id = Number.parseInt(key, 10)
      if (!isNaN(id)) {
        result.push({
          id: id,
          name: i18n.t(`cmmfGroup.${CMMFGroup[id]}`).toString()
        })
      }
    }

    return result
  }

  @Mutation
  public updateCMMFCache (params: { key: string; value: CMMF[] }) {
    this.cmmfCache[params.key] = params.value

    for (const callback of this.callbacks) {
      callback()
    }
  }

  @Mutation
  private updateWorklist (worklist: Worklist[]) {
    this.worklist.splice(0, this.worklist.length, ...worklist)
  }

  @Mutation
  public updateFilter(filter: PromotionListFilter) {
    this.filter = filter
  }

  @Action({ rawError: true })
  public async loadCMMF (salesOrgId: number): Promise<CMMF[]> {
    try {
      return await serviceModule.cmmfApi.searchCMMFs(salesOrgId)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  @Action({ rawError: true })
  public async fetchWorkList () {
    const result = await serviceModule.promotionApi.getMyWorklist()
    this.updateWorklist(result)
  }
}

export default getModule(PromotionModule)
